type LoadingDisplayState = 'hidden' | 'loader' | 'content'

/**
 * Decides when to show a loader so its appearance is flicker free and never looks buggy or janky:
 * fast loads skip the loader entirely, and a shown loader stays up long enough to not flash.
 */
export default function useLoaderVisibility(
  isLoading: MaybeRefOrGetter<boolean>,
  { showLoaderAfterMs = 200, minLoaderVisibleMs = 500 } = {}
) {
  const isShowLoaderDelayOver = useTimeout(showLoaderAfterMs)
  const isMinLoaderVisibilityOver = useTimeout(showLoaderAfterMs + minLoaderVisibleMs)

  const displayState = ref<LoadingDisplayState>(toValue(isLoading) ? 'hidden' : 'content')

  watchEffect(() => {
    const isStillLoading = toValue(isLoading)
    if (displayState.value === 'hidden') {
      if (!isStillLoading) displayState.value = 'content'
      else if (isShowLoaderDelayOver.value) displayState.value = 'loader'
    } else if (displayState.value === 'loader' && !isStillLoading && isMinLoaderVisibilityOver.value) {
      displayState.value = 'content'
    }
  })

  return {
    isLoaderShown: computed(() => displayState.value === 'loader'),
    isContentShown: computed(() => displayState.value === 'content'),
  }
}
